import { ServiceManager } from "../../services/service-manager";
import { HttpMessage } from "../models/http-message";
import { HttpStatusCode } from "../models/http-status-codes";
import { severity } from "../models/severity.enum";

export class HttpService {

    urlBackend = 'http://localhost:3005';

    async get<T>(path: string, contextualMessages?: HttpMessage): Promise<{ response: Response, data: T }> {
        let response;
        
        if(path.includes('http')){
            response = await fetch(`${path}`);
        } else {
            response = await fetch(`${this.urlBackend}/${path}`);
        }

        if (response.status === HttpStatusCode.Ok) {
            const data = await response.json();
            if (contextualMessages && contextualMessages.successMessage) {
                ServiceManager.snackbarService.openSnackbar(contextualMessages.successMessage, severity.success);
            }
            return { response, data };
        } else {
            if (contextualMessages && contextualMessages.errorMessage) {
                ServiceManager.snackbarService.openSnackbar(contextualMessages.errorMessage, severity.error);
            } else {
                ServiceManager.snackbarService.openSnackbar(`HTTP Error ${response.status}: '${this.convertHttpStatusCodeToText(response.status)}' for '${path}'`, severity.error);
            }
        }
    }

    async post<T>(path: string, body: T): Promise<{ response: Response, data: T }> {
        const response = await fetch(`${this.urlBackend}/${path}`,
            {
                body: JSON.stringify(body),
                headers:
                    { 'Content-type': 'application/json' },
                method: 'POST',
            });
        const data = await response.json();
        return { response, data }
    }

    async put<T>(path: string, body: T): Promise<{ response: Response, data: T }> {
        const response = await fetch(`${this.urlBackend}/${path}`,
            {
                body: JSON.stringify(body),
                headers:
                    { 'Content-type': 'application/json' },
                method: 'PUT',
            });
        const data = await response.json();
        return { response, data };
    }

    async delete<T>(path: string): Promise<{ response: Response, data: T }> {
        const response = await fetch(`${this.urlBackend}/${path}`,
            {
                headers: { 'Content-type': 'application/json' },
                method: 'DELETE',
            }
        );
        const data = await response.json();
        return { response, data };
    }

    convertHttpStatusCodeToText(code: number) {
        let text = HttpStatusCode[code];
        if (!text) {
            text = 'Unknown';
        }
        return text;
    }
}